/* MODA Sculpt — theme interactions */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var R = window.MODA || {};

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = R.moneyFormat || '{{amount}}';
    var v = (cents / 100);
    function num(dec, sep, thou) {
      var s = v.toFixed(dec);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p.length > 1 ? p.join(sep) : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      if (k === 'amount') return num(2, '.', ',');
      if (k === 'amount_no_decimals') return num(0, '.', ',');
      if (k === 'amount_with_comma_separator') return num(2, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return num(0, ',', '.');
      if (k === 'amount_with_space_separator') return num(2, ',', ' ');
      if (k === 'amount_no_decimals_with_space_separator') return num(0, ',', ' ');
      return num(2, '.', ',');
    });
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(m) {
    var t = $('#toast'); if (!t) return;
    t.textContent = m; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }
  window.modaToast = toast;

  /* ---------- loader (first visit only) ---------- */
  var loader = $('#loader');
  if (loader) {
    var seen;
    try { seen = sessionStorage.getItem('moda_seen'); } catch (e) { seen = null; }
    if (seen) { loader.style.transition = 'none'; loader.classList.add('done'); }
    else {
      try { sessionStorage.setItem('moda_seen', '1'); } catch (e) {}
      var calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
      setTimeout(function () {
        if (calm) { loader.classList.add('done'); return; }
        document.documentElement.classList.add('intro');
        loader.classList.add('zoom');
        setTimeout(function () { loader.style.transition = 'none'; loader.classList.add('done'); }, 1250);
        setTimeout(function () { document.documentElement.classList.remove('intro'); }, 1900);
      }, 1600);
    }
  }
  var firstVisit = !!(loader && !loader.classList.contains('done') && !loader.style.transition);
  setTimeout(function () { var h = $('#hero'); if (h) h.classList.add('in'); }, firstVisit ? 1900 : 120);

  /* ---------- cursor ---------- */
  var ring = $('#ring'), dot = $('.cur');
  if (ring && dot && matchMedia('(hover:hover) and (pointer:fine)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
    var mx = 0, my = 0, rx = 0, ry = 0, moving = false;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
      if (!moving) { moving = true; requestAnimationFrame(loop); }
    }, { passive: true });
    function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      if (Math.abs(mx - rx) + Math.abs(my - ry) > 0.3) requestAnimationFrame(loop); else moving = false;
    }
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest('a,button,summary,.rail,.hs,input,select');
      ring.classList.toggle('hov', !!t);
      var lab = '';
      if (t) {
        if (t.classList.contains('tile')) lab = 'View';
        else if (t.classList.contains('rail')) lab = 'Drag';
        else if (t.classList.contains('card')) lab = 'View';
      }
      ring.classList.toggle('txt', !!lab);
      ring.dataset.label = lab;
    });
  } else {
    document.body.style.cursor = 'auto';
    if (dot) dot.remove(); if (ring) ring.remove();
    var st = document.createElement('style');
    st.textContent = 'button,a,summary,label{cursor:pointer!important}input,textarea{cursor:text!important}';
    document.head.appendChild(st);
  }

  /* ---------- marquee ---------- */
  $$('[data-marquee]').forEach(function (el) {
    var items = Array.prototype.slice.call(el.children);
    if (!items.length) return;
    items.forEach(function (n) { el.appendChild(n.cloneNode(true)); });
  });

  /* ---------- reveal + count up ---------- */
  function countUp(b) {
    var n = parseFloat(b.dataset.count), pre = b.dataset.prefix || '', suf = b.dataset.suffix || '', t0;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / 1200);
      b.textContent = pre + Math.round(n * (1 - Math.pow(1 - p, 3))) + suf;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      io.unobserve(e.target);
      $$('[data-count]', e.target).forEach(countUp);
    });
  }, { threshold: 0.15 });
  function observe() { $$('.rv:not(.in),.lines:not(.in),.band:not(.in)').forEach(function (el) { io.observe(el); }); }
  observe();

  /* ---------- parallax ---------- */
  var plxQ = false;
  function plx() {
    if (plxQ) return; plxQ = true;
    requestAnimationFrame(function () {
      plxQ = false;
      $$('[data-plx]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        el.style.transform = 'translateY(' + (p * -100 * parseFloat(el.dataset.plx)) + '%)';
      });
    });
  }
  plx();

  /* ---------- header ---------- */
  var nav = $('#nav');
  addEventListener('scroll', function () {
    if (nav) nav.classList.toggle('solid', scrollY > 40);
    plx();
  }, { passive: true });

  var mega = $('#mega'), megaT;
  var megaTrigger = $('[data-mega]');
  if (mega && megaTrigger && nav) {
    megaTrigger.addEventListener('mouseenter', function () {
      clearTimeout(megaT);
      mega.style.top = nav.getBoundingClientRect().bottom + 'px';
      mega.classList.add('open'); nav.classList.add('forced');
    });
    nav.addEventListener('mouseleave', function () {
      megaT = setTimeout(function () {
        if (!mega.matches(':hover')) { mega.classList.remove('open'); nav.classList.remove('forced'); }
      }, 150);
    });
    mega.addEventListener('mouseenter', function () { clearTimeout(megaT); });
    mega.addEventListener('mouseleave', function () { mega.classList.remove('open'); nav.classList.remove('forced'); });
  }

  function closeAll() {
    $$('.drawer,.dim,.modal,.search,.mnav,.mega').forEach(function (x) { x.classList.remove('open'); });
    if (nav) nav.classList.remove('forced');
  }
  window.modaCloseAll = closeAll;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeAll); });

  var burger = $('#burger'), mnav = $('#mnav'), mclose = $('#mclose');
  if (burger && mnav) burger.addEventListener('click', function () { mnav.classList.add('open'); });
  if (mclose) mclose.addEventListener('click', closeAll);

  /* ---------- search ---------- */
  var sbtn = $('#sbtn'), search = $('#search'), sclose = $('#sclose'), sinput = $('#sinput'), sres = $('#sres');
  if (sbtn && search) {
    sbtn.addEventListener('click', function () {
      search.classList.add('open');
      setTimeout(function () { if (sinput) sinput.focus(); }, 300);
    });
  }
  if (sclose) sclose.addEventListener('click', closeAll);
  var sT;
  function runSearch(q) {
    if (!sres) return;
    q = (q || '').trim();
    if (!q) { sres.innerHTML = ''; return; }
    fetch(R.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-predictive-results]');
        sres.innerHTML = inner ? inner.innerHTML : '<p class="eyebrow">No matches</p>';
      })
      .catch(function () { sres.innerHTML = '<p class="eyebrow">Search unavailable</p>'; });
  }
  if (sinput) sinput.addEventListener('input', function (e) { clearTimeout(sT); var v = e.target.value; sT = setTimeout(function () { runSearch(v); }, 220); });
  $$('.search [data-q]').forEach(function (b) {
    b.addEventListener('click', function () { if (sinput) { sinput.value = b.dataset.q; runSearch(b.dataset.q); } });
  });

  /* ---------- hero slideshow ---------- */
  (function () {
    var hero = $('#hero'); if (!hero) return;
    var slides = $$('[data-hslide]', hero);
    if (slides.length < 1) return;
    var dots = $$('#dots i'), count = $('#hcount'), h1 = $('#h1');
    var i = 0, t;
    function head(n) {
      if (!h1) return;
      var raw = slides[n].dataset.heading || '';
      h1.innerHTML = raw.split('|').map(function (l) { return '<span class="w"><span>' + l + '</span></span>'; }).join('<br>');
      hero.classList.remove('in'); void h1.offsetWidth; hero.classList.add('in');
    }
    var panelImgs = $$('.panel img', hero);
    function go(n) {
      i = (n + slides.length) % slides.length;
      panelImgs.forEach(function (im) { im.classList.toggle('on', parseInt(im.dataset.i, 10) === i); });
      dots.forEach(function (d, k) { d.classList.remove('on'); void d.offsetWidth; if (k === i) d.classList.add('on'); });
      if (count) count.textContent = '0' + (i + 1) + ' / 0' + slides.length;
      head(i);
      clearTimeout(t);
      if (slides.length > 1) t = setTimeout(function () { go(i + 1); }, 6000);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    go(0);
  })();

  /* ---------- collection banner slideshow ---------- */
  (function () {
    var hero = $('#colhero'); if (!hero) return;
    var slides = $$('.sl', hero); if (!slides.length) return;
    var num = $('#colnum span'), bar = $('#colbar'), cap = $('#colcap');
    var i = -1, t;
    function go(n, dir) {
      var next = (n + slides.length) % slides.length;
      if (next === i) return;
      dir = dir || 1;
      hero.classList.toggle('rev', dir < 0);
      slides.forEach(function (x, k) {
        x.classList.remove('out', 'pre');
        if (k === i) { x.classList.remove('on'); x.classList.add('out'); }
      });
      var nx = slides[next];
      nx.classList.remove('on'); nx.classList.add('pre'); void nx.offsetWidth;
      nx.classList.remove('pre'); nx.classList.add('on');
      i = next;
      if (num) {
        num.style.transition = 'none'; num.style.transform = 'translateY(110%)';
        num.textContent = String(i + 1).padStart(2, '0');
        void num.offsetWidth; num.style.transition = ''; num.style.transform = '';
      }
      if (cap) {
        cap.style.opacity = 0;
        setTimeout(function () { cap.textContent = nx.dataset.cap || ''; cap.style.transition = 'opacity .8s'; cap.style.opacity = 1; }, 350);
      }
      if (bar) { bar.classList.remove('on'); void bar.offsetWidth; bar.classList.add('on'); }
      clearTimeout(t);
      if (slides.length > 1) t = setTimeout(function () { go(i + 1, 1); }, 6000);
    }
    var prev = $('#colprev'), next = $('#colnext');
    if (prev) prev.addEventListener('click', function () { go(i - 1, -1); });
    if (next) next.addEventListener('click', function () { go(i + 1, 1); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(i + 1, 1);
      if (e.key === 'ArrowLeft') go(i - 1, -1);
    });
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
    go(0, 1);
  })();

  /* ---------- collection piece filter ---------- */
  (function () {
    var pills = $('#pills'); if (!pills) return;
    var grid = $('#colgrid'), cnt = $('#colcnt');
    pills.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]'); if (!b) return;
      $$('[data-filter]', pills).forEach(function (x) { x.classList.toggle('on', x === b); });
      var f = b.dataset.filter, shown = 0;
      $$('.card', grid).forEach(function (c) {
        var hit = !f || c.dataset.type === f;
        c.style.display = hit ? '' : 'none';
        if (hit) shown++;
      });
      $$('.cg', grid).forEach(function (g) {
        var any = $$('.card', g).some(function (c) { return c.style.display !== 'none'; });
        g.style.display = any ? '' : 'none';
        var feat = $('.cg-feat', g); if (feat) feat.style.display = f ? 'none' : '';
      });
      if (cnt) cnt.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    });
  })();

  /* ---------- drag rails ---------- */
  $$('.rail').forEach(function (r) {
    var x, sl, dn = false;
    r.addEventListener('mousedown', function (e) { dn = true; x = e.pageX; sl = r.scrollLeft; r.classList.add('drag'); });
    addEventListener('mouseup', function () { dn = false; r.classList.remove('drag'); });
    r.addEventListener('mousemove', function (e) { if (!dn) return; e.preventDefault(); r.scrollLeft = sl - (e.pageX - x); });
    r.addEventListener('click', function (e) { if (Math.abs(r.scrollLeft - sl) > 6) e.preventDefault(); }, true);
  });

  /* ---------- cart ---------- */
  var cart = { items: [], total: 0, count: 0 };
  function renderCart() {
    var ct = $('#bagct'); if (ct) { ct.textContent = cart.count; ct.classList.remove('pop'); void ct.offsetWidth; ct.classList.add('pop'); }
    var dr = $('#drct'); if (dr) dr.textContent = cart.count + (cart.count === 1 ? ' item' : ' items');
    var sub = $('#subtot'); if (sub) sub.textContent = money(cart.total);
    var left = Math.max(0, (R.freeShipThreshold || 50000) - cart.total);
    var st = $('#shiptxt');
    if (st) st.innerHTML = left > 0
      ? 'You\'re <b style="font-weight:400">' + money(left) + '</b> away from complimentary shipping'
      : '<b style="font-weight:400">Complimentary shipping unlocked</b> ✦';
    var sb = $('#shipbar');
    if (sb) sb.style.transform = 'scaleX(' + Math.min(1, cart.total / (R.freeShipThreshold || 50000)) + ')';
    var wrap = $('#items'); if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="empty"><h4>Your bag is empty</h4><p>Start with Evolve.</p><a class="btn btn-od" href="/collections/evolve" style="margin-top:20px">Shop Evolve</a></div>';
      return;
    }
    wrap.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      return '<div class="item">' +
        '<a class="th" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
        '<div><h4>' + it.product_title + '</h4><small>' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</small>' +
        '<div class="qty"><button data-k="' + it.key + '" data-d="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-k="' + it.key + '" data-d="1" aria-label="Increase">+</button></div>' +
        '<button class="rm" data-rm="' + it.key + '">Remove</button></div>' +
        '<span class="p">' + money(it.line_price) + '</span></div>';
    }).join('');
  }
  function readCart() {
    return fetch(R.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart.items = c.items || []; cart.total = c.total_price || 0; cart.count = c.item_count || 0;
        renderCart(); return c;
      });
  }
  function openDrawer() { var d = $('#drawer'), dm = $('#dim'); if (d) d.classList.add('open'); if (dm) dm.classList.add('open'); }
  window.modaOpenDrawer = openDrawer;

  function addToCart(id, qty, label) {
    return fetch(R.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || 'Sold out'); return; }
        return readCart().then(function () { openDrawer(); toast((label || 'Added') + ' added'); });
      }).catch(function () { toast('Something went wrong'); });
  }
  window.modaAdd = addToCart;

  function changeLine(key, qty) {
    return fetch(R.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) {
      cart.items = c.items || []; cart.total = c.total_price || 0; cart.count = c.item_count || 0;
      renderCart();
      if (document.body.classList.contains('tmpl-cart')) location.reload();
    });
  }
  var itemsEl = $('#items');
  if (itemsEl) itemsEl.addEventListener('click', function (e) {
    var q = e.target.closest('[data-k]'), rm = e.target.closest('[data-rm]');
    if (q) {
      var line = cart.items.filter(function (i) { return i.key === q.dataset.k; })[0];
      if (line) changeLine(q.dataset.k, line.quantity + parseInt(q.dataset.d, 10));
    }
    if (rm) changeLine(rm.dataset.rm, 0);
  });
  var bagbtn = $('#bagbtn');
  if (bagbtn) bagbtn.addEventListener('click', function () { openDrawer(); });
  var dclose = $('#dclose'), dim = $('#dim');
  if (dclose) dclose.addEventListener('click', closeAll);
  if (dim) dim.addEventListener('click', closeAll);
  readCart();

  /* ---------- quick add ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-qa]');
    if (!qa) return;
    e.preventDefault(); e.stopPropagation();
    var btn = e.target.closest('button[data-vid]');
    if (btn) {
      if (btn.disabled) return;
      addToCart(btn.dataset.vid, 1, btn.dataset.label || 'Item');
      qa.classList.remove('pick');
    } else {
      qa.classList.add('pick');
    }
  });

  /* ---------- size guide ---------- */
  var SG = {
    bra: { label: 'Bra', rows: [['Front length', 30.4, 31, 31.6, 32.2, 32.8], ['Chest (circumference)', 68, 72, 76, 80, 84], ['Underband (circumference)', 58, 62, 66, 70, 74], ['Band height', 3.5, 3.5, 3.5, 3.5, 3.5], ['Strap width', 3.5, 3.5, 3.5, 3.5, 3.5]], note: 'Chest and underband are full circumferences. Compressive fit: if you are between sizes and prefer a lighter hold, size up.' },
    shorts: { label: 'Shorts', rows: [['Front length', 30.5, 31.5, 32.5, 33.5, 34.5], ['Waist (circumference)', 48, 52, 56, 60, 64], ['Hip (circumference)', 68, 72, 76, 80, 84], ['Leg opening (circumference)', 37, 39, 41, 43, 45], ['Front rise', 24, 25, 26, 27, 28], ['Back rise', 35, 36, 37, 38, 39]], note: 'Waist and hip are relaxed garment measurements and stretch to fit. Rise is measured including the waistband.' },
    leggings: { label: 'Leggings', rows: [['Front length', 86, 88, 90, 92, 94], ['Waist (circumference)', 48, 52, 56, 60, 64], ['Hip (circumference)', 68, 72, 76, 80, 84], ['Knee (circumference)', 28, 29.5, 31, 32.5, 34], ['Ankle opening (circumference)', 18, 19, 20, 21, 22], ['Front rise', 23.5, 24.5, 25.5, 26.5, 27.5], ['Back rise', 34, 35, 36, 37, 38]], note: 'Waist and hip are relaxed garment measurements and stretch to fit. Rise is measured including the waistband. Hip taken 8cm below the waist, knee 32cm below.' }
  };
  var SGS = ['XS', 'S', 'M', 'L', 'XL'];
  var SGCONV = [['UK', '4–6', '8–10', '12–14', '16–18', '20'], ['US', '0–2', '4–6', '8–10', '12–14', '16'], ['EU', '32–34', '36–38', '40–42', '44–46', '48']];
  var SGFIT = '<div class="sgfit"><h4>Our fit recommendation</h4><p>MODA is cut to sculpt. Every piece is made from a compressive four-way stretch fabric that moulds to you, so most customers take their usual size. If you want a more sculpted, second-skin feel, or you are between sizes, size down.</p></div>';
  function sgConv() {
    return '<table class="sgt conv"><thead><tr><th></th>' + SGS.map(function (z) { return '<th>' + z + '</th>'; }).join('') + '</tr></thead><tbody>' +
      SGCONV.map(function (r) { return '<tr><td>' + r[0] + '</td>' + r.slice(1).map(function (v) { return '<td>' + v + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table>';
  }
  function sgTable(kind) {
    var g = SG[kind];
    return '<table class="sgt"><thead><tr><th></th>' + SGS.map(function (z) { return '<th>' + z + '</th>'; }).join('') + '</tr></thead><tbody>' +
      g.rows.map(function (r) { return '<tr><td>' + r[0] + '</td>' + r.slice(1).map(function (v) { return '<td>' + v + '</td>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table><p class="sgnote">' + g.note + '</p>';
  }
  function sgMount(root, kind) {
    if (!root) return;
    kind = SG[kind] ? kind : 'bra';
    root.innerHTML = sgConv() + SGFIT + '<h4 class="sgh">Garment measurements · cm</h4><div class="sgpick pills">' +
      Object.keys(SG).map(function (k) { return '<button type="button" class="pill ' + (k === kind ? 'on' : '') + '" data-sgk="' + k + '">' + SG[k].label + '</button>'; }).join('') +
      '</div><div class="sgbody">' + sgTable(kind) + '</div>';
    $$('[data-sgk]', root).forEach(function (b) {
      b.style.cursor = 'pointer'; b.style.position = 'relative'; b.style.zIndex = '5';
      var go = function (ev) { ev.preventDefault(); ev.stopPropagation(); sgMount(root, b.dataset.sgk); };
      b.addEventListener('pointerup', go); b.addEventListener('click', go); b.addEventListener('touchend', go);
    });
  }
  window.modaSizeGuide = sgMount;
  $$('[data-sgroot]').forEach(function (el) { sgMount(el, el.dataset.sgroot); });
  $$('[data-sizeguide]').forEach(function (b) {
    b.addEventListener('click', function () {
      sgMount($('#sgmodal'), b.dataset.sizeguide);
      var m = $('#sizemodal'); if (m) m.classList.add('open');
    });
  });

  /* ---------- product page ---------- */
  (function () {
    var pdp = $('#pdp'); if (!pdp) return;
    var shots = $$('.gal-main .sh'), thumbs = $$('.thumbs button');
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = $('[data-sh="' + b.dataset.g + '"]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) shots.forEach(function (sh) {
      sh.addEventListener('mousemove', function (e) {
        var r = sh.getBoundingClientRect(), im = sh.firstElementChild;
        if (!im) return;
        im.style.setProperty('--ox', ((e.clientX - r.left) / r.width * 100) + '%');
        im.style.setProperty('--oy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
    if (shots.length) {
      var gio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          thumbs.forEach(function (b) { b.classList.toggle('on', b.dataset.g === e.target.dataset.sh); });
        });
      }, { threshold: 0.6 });
      shots.forEach(function (s) { gio.observe(s); });
    }

    var form = $('#pform'), idInput = $('#pvid'), atc = $('#atc');
    var variants = [];
    try { variants = JSON.parse($('#pvariants').textContent); } catch (e) {}
    var chosen = null;
    function setSize(btn) {
      $$('.sz button').forEach(function (x) { x.classList.remove('on'); });
      btn.classList.add('on');
      chosen = variants.filter(function (v) { return String(v.id) === btn.dataset.vid; })[0] || null;
      if (idInput && chosen) idInput.value = chosen.id;
      var sb = $('#sb-size'); if (sb) sb.textContent = btn.textContent.trim();
    }
    $$('.sz button').forEach(function (b) {
      b.addEventListener('click', function () { if (!b.disabled) setSize(b); });
    });
    var avail = $$('.sz button').filter(function (b) { return !b.disabled; });
    if (avail.length === 1) setSize(avail[0]);

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!chosen) {
        toast('Choose a size');
        var szEl = $('.sz');
        if (szEl && szEl.animate) szEl.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 350 });
        return;
      }
      addToCart(chosen.id, 1, form.dataset.title);
    });

    var bar = $('#stickybar');
    if (bar && atc) {
      var sio = new IntersectionObserver(function (es) { bar.classList.toggle('show', !es[0].isIntersecting); });
      sio.observe(atc);
      var barBtn = $('#sb-add');
      if (barBtn) barBtn.addEventListener('click', function () { if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    }
  })();

  /* ---------- help scrollspy ---------- */
  (function () {
    var secs = $$('.hsec'); if (!secs.length) return;
    var hio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        $$('#helpnav a').forEach(function (a) { a.classList.toggle('on', 'h-' + a.dataset.h === e.target.id); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    secs.forEach(function (s) { hio.observe(s); });
    if (location.hash) {
      var el = document.getElementById(location.hash.slice(1));
      if (el) setTimeout(function () { el.scrollIntoView({ behavior: 'smooth' }); }, 200);
    }
  })();

  /* ---------- follow peek ---------- */
  (function () {
    var peek = $('#peek'); if (!peek) return;
    $$('#soc a').forEach(function (a) {
      a.addEventListener('mouseenter', function () { var im = peek.firstElementChild; if (im) im.src = a.dataset.peek; peek.classList.add('on'); });
      a.addEventListener('mouseleave', function () { peek.classList.remove('on'); });
      a.addEventListener('mousemove', function (e) { peek.style.left = e.clientX + 'px'; peek.style.top = e.clientY + 'px'; });
    });
  })();

  /* ---------- page transition veil ---------- */
  (function () {
    var veil = $('#veil'); if (!veil) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      if (a.hostname && a.hostname !== location.hostname) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      veil.classList.remove('go'); void veil.offsetWidth; veil.classList.add('go');
      setTimeout(function () { location.href = a.href; }, 480);
    });
  })();
  /* ---------- welcome offer popup ---------- */
  (function () {
    var wo = $('#wo'); if (!wo) return;
    var tab = $('#wo-tab'), form = $('#wo-form'), code = wo.dataset.code || '';
    var KEY = 'moda_wo', root = document.documentElement, lastFocus = null;
    function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
    function set(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    var st = get();
    var days = parseFloat(wo.dataset.days) || 14;

    function open() {
      if (wo.classList.contains('open')) return;
      lastFocus = document.activeElement;
      wo.setAttribute('aria-hidden', 'false');
      wo.classList.add('open');
      if (tab) tab.classList.remove('show');
      root.style.overflow = 'hidden';
      if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
        setTimeout(function () { var e = $('#wo-em'); if (e && !wo.classList.contains('ok')) e.focus({ preventScroll: true }); }, 1000);
      }
    }
    function close() {
      if (!wo.classList.contains('open')) return;
      wo.classList.remove('open');
      wo.setAttribute('aria-hidden', 'true');
      root.style.overflow = '';
      if (!wo.classList.contains('ok')) {
        set({ closed: Date.now() });
        if (tab) setTimeout(function () { tab.classList.add('show'); }, 500);
      }
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    $$('[data-wo-close]', wo).forEach(function (b) { b.addEventListener('click', close); });
    if (tab) tab.addEventListener('click', open);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var copy = $('#wo-copy');
    if (copy) copy.addEventListener('click', function () {
      try { navigator.clipboard.writeText(code); } catch (e) {}
      copy.textContent = 'Copied';
      setTimeout(function () { copy.textContent = 'Copy'; }, 1600);
    });

    /* apply the code to this shopper's cart/checkout */
    function applyCode() {
      if (!code || !window.fetch) return;
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' })
        .then(function (r) { if (r.ok) { var a = $('#wo-applied'); if (a) a.classList.add('on'); } })
        .catch(function () {});
    }
    function success() {
      set({ subscribed: Date.now() });
      if (tab) tab.classList.remove('show');
      wo.classList.add('ok');
      applyCode();
    }

    /* came back from a normal (non-AJAX) form post */
    if ($('[data-wo-posted]', wo) || /[?&]customer_posted=true/.test(location.search) && location.hash === '#wo-form') {
      open(); success(); return;
    }
    if (st.subscribed) return;

    if (form) form.noValidate = true;
    if (form) form.addEventListener('submit', function (e) {
      var em = $('#wo-em'), fld = $('#wo-fld'), v = ((em && em.value) || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { e.preventDefault(); if (fld) fld.classList.add('bad'); return; }
      if (fld) fld.classList.remove('bad');
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $('.wo-cta', form); if (btn) btn.classList.add('busy');
      function native() { HTMLFormElement.prototype.submit.call(form); }
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (/\/challenge/.test(r.url)) { native(); return; }
          return r.text().then(function (html) {
            if (btn) btn.classList.remove('busy');
            if (/customer_posted=true/.test(r.url) || html.indexOf('data-wo-posted') > -1) success();
            else native();
          });
        })
        .catch(native);
    });

    if (st.closed && Date.now() - st.closed < days * 864e5) {
      if (tab) setTimeout(function () { tab.classList.add('show'); }, 1200);
      return;
    }

    var fired = false;
    function busy() { return !!$('.drawer.open,.modal.open,.search.open,.mnav.open'); }
    function fire() {
      if (fired) return;
      if (busy()) { setTimeout(fire, 4000); return; }
      fired = true; open();
    }
    function arm() {
      setTimeout(fire, (parseFloat(wo.dataset.delay) || 8) * 1000);
      function onScroll() {
        var h = document.documentElement.scrollHeight - innerHeight;
        if (h > 0 && scrollY / h > 0.35) { removeEventListener('scroll', onScroll); fire(); }
      }
      addEventListener('scroll', onScroll, { passive: true });
      if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
        document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) fire(); });
      }
    }
    /* never interrupt the MODA intro */
    (function wait() {
      var l = $('#loader');
      if ((!l || l.classList.contains('done')) && !root.classList.contains('intro')) arm();
      else setTimeout(wait, 250);
    })();
  })();
})();
